import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import packages from "../data/packages";
import styles from "./PackageSelect.module.css";

function PackageSelect() {
  const { addToCart } = useCart();

  const handleAddToCart = (e, pkg) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart({
      id: pkg.id,
      name: pkg.name,
      price: pkg.price,
      type: "package",
    });
  };

  return (
    <section id="packages" className={styles.section}>
      <div className="container">
        <h2 className={styles.title}>Select Your Safari Package</h2>

        <div className="row g-4">
          {packages.map((pkg, index) => (
            <div key={pkg.id} className="col-12 col-sm-6 col-lg-3">
              <Link
                to={`/package/${pkg.id}`}
                className={styles.cardLink}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className={styles.card}>
                  <div className={styles.imageWrap}>
                    <img
                      src={pkg.image}
                      alt={pkg.name}
                      className={styles.image}
                    />

                    {pkg.featured && (
                      <span className={styles.featuredBadge}>Featured</span>
                    )}

                    <span
                      className={`${styles.priceRibbon} ${
                        styles[pkg.variant]
                      }`}
                    >
                      From AED {pkg.price}
                    </span>
                  </div>

                  <div className={styles.body}>
                    <div className={styles.metaRow}>
                      <span className={styles.rating}>
                        <span aria-hidden="true">★</span> {pkg.rating.toFixed(1)}{" "}
                        <span className={styles.reviewCount}>
                          ({pkg.reviewCount})
                        </span>
                      </span>
                    </div>

                    <p className={styles.pkgName}>{pkg.name}</p>

                    <p className={styles.location}>
                      <span aria-hidden="true">📍</span> {pkg.location}
                    </p>

                    <div className={styles.infoBar}>
                      <span className={styles.infoItem}>
                        <span aria-hidden="true">🕑</span> {pkg.duration}
                      </span>
                      <span className={styles.infoItem}>
                        <span aria-hidden="true">👥</span> {pkg.groupSize}
                      </span>
                    </div>

                    <div className={styles.buttonRow}>
                      <button
                        type="button"
                        className={styles.cartBtn}
                        onClick={(e) => handleAddToCart(e, pkg)}
                      >
                        Add to Cart
                      </button>
                      <span
                        className={`${styles.detailsBtn} ${
                          styles[pkg.variant + "Btn"]
                        }`}
                      >
                        View Details
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PackageSelect;
